export default "__VITE_ASSET__DySm2dP8__"